import { Shape } from '@tokamap/core';

/** `undefined` si `shapes` est vide ou si `getter` renvoie des valeurs différentes selon la forme. */
export function commonValue<T>(shapes: Shape[], getter: (shape: Shape) => T): T | undefined {
	if (!shapes.length) return undefined;

	const first = getter(shapes[0]!);

	return shapes.every(shape => getter(shape) === first) ? first : undefined;
}
